define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rmargin.js
// module id = 441
// module chunks = 243